<template>
  <router-view/>
</template>

<style>
/*  页面整体样式  */
body,div,img{margin: 0px; border: 0px; padding: 0px;}
body{text-align: center;}
/*  flex 弹性布局样式  */
.containner{width: 1200px; margin: 0 auto;}
.flex{display: flex; flex-direction: row;}
.flex-column{display: flex; flex-direction: column;}
.justify-center{justify-content: center;}
.justify-end{justify-content: flex-end;}
.justify-between{justify-content: space-between;}
.justify-around{justify-content: space-around;}
.item-start{align-items: flex-start;}
.item-end{align-items: flex-end;}
.item-center{align-items: center; }
.wrap{flex-wrap: wrap;}
/*  特殊效果样式  */
.router-link{color: inherit; text-decoration: none;}
.hand{cursor: pointer;}
.rounded{border-radius:6px;}
.box-shadow{box-shadow:0px 0px 10px #ccc;}
.hover-box-shadow:hover{box-shadow:0px 0px 10px #ccc;}
.hover-box-shadow-red:hover{box-shadow:0px 0px 10px #e1251b;}
.hover-box-shadow-blue:hover{box-shadow:0px 0px 10px #acc;}
/*  文本样式  */
.text-xs{font-size:10px;}
.text-sm{font-size:12px;}
.text-md{font-size:14px;}
.text-lg{font-size:16px;}
.text-xl{font-size:18px;}
.text-48{font-size:48px;}
.text-left{text-align:left;}
.text-right{text-align:right;}
.bold{font-weight:600;}
.weight{font-weight:900;}
/*  定位样式  */
.relative{position: relative;}
.absolute{position: absolute;}
.l-0{left:0px;}
.l-5{left:5px;}
.l-10{left:10px;}
.l-20{left:20px;}
.r-0{right: 0px;}
.r-5{right:5px;}
.r-10{right:10px;}
.r-20{right:20px;}
.t-0{top:0px}
.t-5{top:5px}
.t-10{top:10px}
.t-20{top:20px}
.b-0{bottom: 0px;}
.b-5{bottom: 5px;}
.b-10{bottom: 10px;}
.b-20{bottom: 20px;}
.z-low{z-index: 1;}
.z-mid{z-index: 2;}
.z-high{z-index: 3;}
/*  盒子模型样式  */
.w-100{width:100%}
.w-5{width:5%}
.w-10{width:10%}
.w-15{width:15%}
.w-20{width:20%}
.w-25{width:25%}
.w-30{width:30%}
.w-35{width:35%}
.w-40{width:40%}
.w-45{width:45%}
.w-50{width:50%}
.w-55{width:55%}
.w-60{width:60%}
.w-65{width:65%}
.w-70{width:70%}
.w-75{width:75%}
.w-80{width:80%}
.w-85{width:85%}
.w-90{width:90%}
.w-95{width:95%}
.h-100{width:100%}
.mr-5{margin-right: 5px;}
.mr-10{margin-right: 10px;}
.mr-20{margin-right: 20px;}
.mr-40{margin-right: 40px;}
.mt-40{margin-top:40px;}
.mt-30{margin-top:30px;}
.mt-20{margin-top:20px;}
.mt-10{margin-top:10px;}
.mt-5{margin-top:5px;}
.ml-40{margin-left:40px;}
.ml-20{margin-left:20px;}
.ml-10{margin-left:10px;}
.mb-40{margin-bottom:40px;}
.mb-20{margin-bottom:20px;}
.mb-10{margin-bottom:10px;}
.mb-5{margin-bottom:5px;}
.mx-5{margin-left:5px; margin-right:5px;}
.mx-10{margin-left:10px; margin-right:10px;}
.mx-20{margin-left:20px; margin-right:20px;}
.mx-40{margin-left:40px; margin-right:40px;}
.my-5{margin-top:5px; margin-bottom:5px;}
.my-10{margin-top:10px; margin-bottom:10px;}
.my-20{margin-top:20px; margin-bottom:20px;}
.my-40{margin-top:40px; margin-bottom:40px;}
.px-5{padding-left:5px; padding-right:5px;}
.px-10{padding-left:10px; padding-right:10px;}
.px-20{padding-left:20px; padding-right:20px;}
.pl-5{padding-left:5px; }
.pl-10{padding-left:10px; }
.pl-20{padding-left:20px; }
.pr-5{padding-right:5px; }
.pr-10{padding-right:10px; }
.pr-20{padding-right:20px; }
.py-5{padding-top:5px; padding-bottom:5px;}
.py-10{padding-top:10px; padding-bottom:10px;}
.py-20{padding-top:20px; padding-bottom:20px;}
.border-bottom{border-bottom: 1px solid #f8f8f8;}
/*  主题样式  */
.red{color:#e1251b;}
.gray{color:#999;}
.white{color:#fff;}
.black{color:#000;}
.bg-white{background-color:#fff;}
.bg-red{background-color:#e1251b;}
.bg-gray{background-color:#f4f4f4;}
.dark{color:#666;}
.hover-red:hover{color:#e1251b;}
.hover-white:hover{color:#fff;}
.hover-bg-red:hover{background-color:#e1251b;}
.hover-bg-gray:hover{background-color:#ddd;}

a{color: darkslategray; text-decoration: none;}

/*  film 影片组件部分  */
.film{width: 160px;}
.film.active{width:200px; box-shadow: 0px 0px 10px #acc;}
/*  film-list 影片列表组件部分  */
.film-list-img{width: 180px; height: 100px; overflow: hidden; }
.film-list-img img{margin-top: -75px;}

</style>
